const keyMirror = require('keymirror');

export const EVENTS = keyMirror({
    GET_PROFILE: null,
    LOGIN_CLICKED: null,
    USER_DATA_UPDATED: null
});